import { Model, Schema } from "src/engine/modules/model/classes"
import omit from "lodash/omit"

const entityName = `/resources/types`

export default new Model({
  name: entityName,
  getRestUrn: (method, id) => (id ? `${entityName}/${id}` : `${entityName}`),
  primaryKey: `id`,
  denormalize: data => omit(data, [`id`]),
  schema: new Schema({}),
})
